/**
 * @generated SignedSource<<4b134f64f11ffd1a4cc70559f78e71c9>>
 * @relayHash cb875b164e467c388678144a56847c99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4a8e2a313c01273300fc41c78b263d8655ffa36feab8671b8a00e403ffdb829

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateDateFieldInput = {
  id: string;
  operation: JiraDateFieldOperationInput;
};
export type JiraDateFieldOperationInput = {
  date?: AGG$Date | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type date_issueFieldDate_DateField_Mutation$variables = {
  input: JiraUpdateDateFieldInput;
};
export type date_issueFieldDate_DateField_Mutation$data = {
  readonly jira: {
    readonly updateDateField: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly date: AGG$Date | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type date_issueFieldDate_DateField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateDateField: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly __typename: "BulkMutationErrorExtension";
          readonly id: string;
          readonly statusCode: number | null | undefined;
        } | {
          readonly __typename: string;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly date: AGG$Date | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type date_issueFieldDate_DateField_Mutation = {
  rawResponse: date_issueFieldDate_DateField_Mutation$rawResponse;
  response: date_issueFieldDate_DateField_Mutation$data;
  variables: date_issueFieldDate_DateField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "date"
},
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "date_issueFieldDate_DateField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDateFieldPayload",
            "kind": "LinkedField",
            "name": "updateDateField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraDatePickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              },
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "date_issueFieldDate_DateField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDateFieldPayload",
            "kind": "LinkedField",
            "name": "updateDateField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraDatePickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/)
                ]
              },
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c4a8e2a313c01273300fc41c78b263d8655ffa36feab8671b8a00e403ffdb829",
    "metadata": {},
    "name": "date_issueFieldDate_DateField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "210cf117686622e3bb1cfb655e147341";

export default node;
